// KEEP THIS IN SYNC WITH CORE https://github.com/reverbdotcom/reverb/blob/master/app/reverb/shop_policies/enable_direct_checkout_policy.rb
export const ADYEN_MARKETPAY_SUPPORTED_COUNTRIES = Object.freeze([
  'AT', // Austria
  'BE', // Belgium
  'DE', // Germany
  'ES', // Spain
  'FI', // Finland
  'FR', // France
  'GB', // United Kingdom
  'IE', // Ireland
  'IT', // Italy
  'NL', // Netherlands
  'PT', // Portugal
]);

export const INTERNAL_PAYOUTS_SUPPORTED_COUNTRIES = Object.freeze([
  'US', // United States,
  'CA', // Canada
]);

export const REVERB_PAYMENTS_SUPPORTED_COUNTRIES = Object.freeze(ADYEN_MARKETPAY_SUPPORTED_COUNTRIES.concat(INTERNAL_PAYOUTS_SUPPORTED_COUNTRIES));



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/src/supported_countries.ts